function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".close_svg__cls-1{fill:none;stroke:#000;stroke-width:2px}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "close_svg__Group_88",
  "data-name": "Group 88",
  transform: "translate(-1119.5 -246.5)"
}, React.createElement("path", {
  id: "close_svg__Line_1",
  d: "M0 0l18 18",
  className: "close_svg__cls-1",
  "data-name": "Line 1",
  transform: "translate(1122.5 249.5)"
}), React.createElement("path", {
  id: "close_svg__Line_2",
  d: "M18 0L0 18",
  className: "close_svg__cls-1",
  "data-name": "Line 2",
  transform: "translate(1122.5 249.5)"
}), React.createElement("path", {
  id: "close_svg__Rectangle_190",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 190",
  transform: "translate(1119.5 246.5)",
  fill: "none"
}));

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxkZWZzPgogICAgICAgIDxzdHlsZT4KICAgICAgICAgICAgLmNscy0xLC5jbHMtMntmaWxsOm5vbmV9LmNscy0xe3N0cm9rZTojMDAwO3N0cm9rZS13aWR0aDoycHh9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJHcm91cF84OCIgZGF0YS1uYW1lPSJHcm91cCA4OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMTkuNSAtMjQ2LjUpIj4KICAgICAgICA8cGF0aCBpZD0iTGluZV8xIiBkPSJNMCAwbDE4IDE4IiBjbGFzcz0iY2xzLTEiIGRhdGEtbmFtZT0iTGluZSAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTIyLjUgMjQ5LjUpIi8+CiAgICAgICAgPHBhdGggaWQ9IkxpbmVfMiIgZD0iTTE4IDBMMCAxOCIgY2xhc3M9ImNscy0xIiBkYXRhLW5hbWU9IkxpbmUgMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyMi41IDI0OS41KSIvPgogICAgICAgIDxwYXRoIGlkPSJSZWN0YW5nbGVfMTkwIiBkPSJNMCAwaDI0djI0SDB6IiBjbGFzcz0iY2xzLTIiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE5MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExOS41IDI0Ni41KSIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgClose as ReactComponent };


//////////////////
// WEBPACK FOOTER
// /src/assets/img/close.svg
// module id = 165
// module chunks = 0